import styled from 'styled-components'
import { tokens } from '../../../assets/tokens'

// «Volver a …» de las páginas: flecha de lucide y texto en 500, alineados en el centro
const BackButtonStyled = styled.div`
  p,
  a {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    font-family: ${tokens.typography.fontFamily.primary};
    font-weight: 500;
    font-size: 14px;
    line-height: 18px;
    color: ${props => (props.color ? props.color : tokens.color.text.tertiary)};
    margin-bottom: 0;

    svg {
      flex-shrink: 0;
    }
  }
`

export default BackButtonStyled
